import { TAchievementId } from '@skillarea/lib-shared';

import loginStreak30Image from '../../routes/account/imgs/login-streak-30.webp';
import loginStreak60Image from '../../routes/account/imgs/login-streak-60.webp';

const CHEST_ACHIEVEMENT_IMAGES: Partial<Record<TAchievementId, string>> = {
  'login-streak-30': loginStreak30Image,
  'login-streak-60': loginStreak60Image,
};

export function getChestAchievementImage(
  achievementId?: TAchievementId,
): string | undefined {
  if (!achievementId) return undefined;
  return CHEST_ACHIEVEMENT_IMAGES[achievementId];
}
